<template>
<div v-show="announcementData" class="announcement-bar-container" :class="{collapsed}">
  <div v-show="!collapsed" class="text-content">
    <p ref="marqueeLight">{{announcementData&&announcementData.content}}</p>
  </div>
  <div class="button" @click="buttonClicked">{{collapsed?'公告':'隐藏'}}</div>
</div>
</template>
<script>
import axios from 'axios'

export default {
  name: 'announcementBar',
  data () {
    return {
      collapsed: false,
      announcementList: null,
      announcementData: null,
      reFilterTimeoutId: null
    }
  },
  methods: {
    getAnnouncementStoreKey () {
      return 'read_announcement_id_' + this.$store.getters.user.id
    },
    runMarqueeLight (delay = 0) {
      this.$nextTick(() => {
        this.$refs.marqueeLight.addEventListener('transitionend', this.marqueeLightRunEnd)
        this.$refs.marqueeLight.addEventListener('webkitTransitionEnd', this.marqueeLightRunEnd)

        const parentWidth = this.$refs.marqueeLight.parentNode.clientWidth
        const marqueeLightWidth = this.$refs.marqueeLight.clientWidth
        this.$refs.marqueeLight.style.transform = `translateX(${parentWidth}px)`
        setTimeout(() => {
          this.$refs.marqueeLight.style.transition = `all ${(parentWidth + marqueeLightWidth) / 100}s linear`
          setTimeout(() => {
            this.$refs.marqueeLight.style.transform = `translateX(-${marqueeLightWidth}px)`
          }, delay)
        }, delay)
      })
    },
    marqueeLightRunEnd (delay = 0) {
      this.$refs.marqueeLight.removeEventListener('transitionend', this.marqueeLightRunEnd)
      this.$refs.marqueeLight.removeEventListener('webkitTransitionEnd', this.marqueeLightRunEnd)

      if (this.$refs.marqueeLight) {
        this.$refs.marqueeLight.style.transition = ''
        this.$refs.marqueeLight.style.transform = ''
      }
      this.$nextTick(() => {
        this.runMarqueeLight(delay)
      })
    },
    buttonClicked () {
      this.collapsed = !this.collapsed
      if (!this.collapsed) {
        this.$nextTick(() => {
          this.marqueeLightRunEnd(200)
        })

        localStorage.removeItem(this.getAnnouncementStoreKey())
      } else {
        this.$refs.marqueeLight.removeEventListener('transitionend', this.marqueeLightRunEnd)
        this.$refs.marqueeLight.removeEventListener('webkitTransitionEnd', this.marqueeLightRunEnd)

        this.$refs.marqueeLight.style.transition = ''
        this.$refs.marqueeLight.style.transform = ''

        localStorage.setItem(this.getAnnouncementStoreKey(), this.announcementData.id)
      }
    },
    async getAnnouncementList () {
      try {
        const response = await axios({ method: 'get', url: window.location.origin + '/static/announcement.json' })
        response.data.data.forEach(item => {
          item.startTime = new Date(item.startTime)
          item.endTime = new Date(item.endTime)
        })
        this.announcementList = response.data.data
        this.filterAnnouncement()
      } catch (e) {
        console.log(e)
      }
    },
    filterAnnouncement () {
      this.announcementData = null
      if (!this.announcementList || !this.announcementList.length) {
        return
      }
      const nowDate = new Date()
      this.announcementList = this.announcementList.filter(item => {
        return nowDate < item.endTime
      })
      // 过滤数组后，数组长度为0的时结束方法
      if (!this.announcementList.length) {
        return
      }

      this.announcementData = this.announcementList.find(item => {
        return item.startTime < nowDate && nowDate < item.endTime
      })
      if (this.announcementData) {
        const readAnnouncementId = localStorage.getItem(this.getAnnouncementStoreKey())
        this.collapsed = this.announcementData.id === readAnnouncementId
        if (!this.collapsed) {
          this.marqueeLightRunEnd(200)
        }
        const timeout = this.announcementData.endTime - nowDate
        this.reFilterTimeoutId = setTimeout(this.filterAnnouncement, timeout)
      } else {
        this.reFilterTimeoutId = setTimeout(this.filterAnnouncement, 6000)
      }
    }
  },
  mounted () {
    this.getAnnouncementList()
  },
  beforeDestroy () {
    this.$refs.marqueeLight.removeEventListener('transitionend', this.marqueeLightRunEnd)
    this.$refs.marqueeLight.removeEventListener('webkitTransitionEnd', this.marqueeLightRunEnd)

    this.reFilterTimeoutId && clearTimeout(this.reFilterTimeoutId)
  }
}
</script>
<style lang="less" scoped>
.announcement-bar-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 64px;
  right: 0;
  width: 100%;
  padding: 2px 3px;
  background-color: #F2DEDF;
  z-index: 10;
  > .text-content {
    flex: 1;
    font-size: 0;
    overflow: hidden;
    > p {
      display: inline-block;
      font-size: 12px;
      color: #C7747C;
      white-space: nowrap;
    }
  }
  > .button {
    margin-left: 10px;
    padding: 2px 5px;
    font-size: 12px;
    color: #FFFFFF;
    background-color: #D3727E;
    border: white 0 solid;
    border-radius: 6px;
    cursor: pointer;
  }
  &.collapsed {
    width: 40px;
    background-color: transparent;
    > .button {
      margin-left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/announcementBar.vue